module.exports = __webpack_public_path__ + "media/images/IMG_1602-288fae18abff0bc7b95e0047fdf36d88.jpg";